import BasicApplication from "./Basic.application";

import {
    validationControlCurrentRequest,
} from "../../redux/actions/Requests/currentRequestControls/validationControl.currentRequest";

class LayoffApplication extends BasicApplication {
    constructor(options) {
        super(options);
        this.dismissalDate = options.dismissalDate;
        this.dismissalObtainingDocumentId = options.dismissalObtainingDocumentId;
        this.dismissalMotives = options.dismissalMotives;
        this.obtainingDocumentAddress = options.obtainingDocumentAddress;
        this.isValid = {
            leaveReasonId: true,
            dismissalDate: true,
            dismissalObtainingDocumentId: true,
            dismissalMotives: true,
            obtainingDocumentAddress: true,
        };
    }

    static sendToValidation(currentRequest, dispatch) {
        const { leaveTypeId } = currentRequest;
        const keysToCheck = {
            12: [
                "leaveReasonId",
                "dismissalDate",
                "dismissalObtainingDocumentId",
                "obtainingDocumentAddress",
                "dismissalMotives",
            ],
        };
        return (
            this.keyChecker(
                keysToCheck[leaveTypeId],
                currentRequest,
                dispatch,
            )
        );
    }

    static keyChecker(arrayOfKeys, currentRequest, dispatch) {
        let result = 0;
        arrayOfKeys.forEach((e) => {
            if (
                !Array.isArray(e) &&
                (currentRequest[`${e}`] === null ||
                    currentRequest[`${e}`] === undefined)
            ) {
                result += 1;
                dispatch(validationControlCurrentRequest(e, false));
            }
            // else
            //     if (Array.isArray(e)) {
            //     const key = [...e].shift();
            //     for (const bloodKey in currentRequest[key]) {
            //         if (
            //             currentRequest[key][bloodKey] === null ||
            //             currentRequest[key][bloodKey] === undefined
            //         ) {
            //             result += 1;
            //             dispatch(
            //                 validationControlCurrentRequest(
            //                     { object: key, innerKey: bloodKey },
            //                     false,
            //                     "object",
            //                 ),
            //             );
            //         }
            //     }
            // }
        });
        if (currentRequest.dismissalMotives && currentRequest.dismissalMotives.length) {
            console.log("WORK1");

            const filteredMotives = currentRequest.dismissalMotives.filter((el) => el.id === 8);
            if (filteredMotives && filteredMotives.length) {
                if (filteredMotives[0].id === 8 && (filteredMotives[0].name === "" || filteredMotives[0].name === " ")) {
                    result += 1;
                    console.log("WORK");
                    dispatch(validationControlCurrentRequest("dismissalMotives", false));
                }
            }
        } else {
            result += 1;
            dispatch(validationControlCurrentRequest("dismissalMotives", false));
        }
        return !result;
    }
}

export default LayoffApplication;
